"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneFieldByConfig = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.camelcase"));
var _lodash2 = _interopRequireDefault(require("lodash.split"));
var _react = require("react");
var _reactCountryFlag = _interopRequireDefault(require("react-country-flag"));
var _reactHookForm = require("react-hook-form");
var _components = require("../components");
var _utils = require("../utils");
var _SharedStyledComponents = require("./SharedStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const FlagWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(3)
}));
const getCountryByCountryCode = (countries, countryCode) => countries?.find(country => country.countryCode === countryCode)?.name;
const PhoneFieldByConfig = props => {
  const {
    name,
    label,
    helperText,
    isEditable,
    isAvailable,
    displayOrder,
    isMandatory,
    initialValue,
    isAddressMatchRequired,
    inputType,
    customPlaceholder,
    enableLowercaseLetters,
    helperTextWithPrefix,
    customPlaceholderWithPrefix,
    labelWithPrefix,
    variant,
    customErrors,
    customerLoginUrl,
    isDisabled,
    autoFocus,
    maxLengthLimit,
    customTenant,
    customMaxWidth
  } = props;
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    setValue,
    watch,
    setFocus
  } = (0, _reactHookForm.useFormContext)();
  const [phonePrefix, setPhonePrefix] = (0, _react.useState)();
  const [isDisabledPrefix, setIsDisabledPrefix] = (0, _react.useState)(false);
  const [phoneAutofocus, setPhoneAutofocus] = (0, _react.useState)(false);
  const [phoneWithoutPrefix, setPhoneWithoutPrefix] = (0, _react.useState)();
  const {
    data: phoneFormats
  } = (0, _staticApiClientReact.useGetTenantPhoneFormats)(customTenant ?? tenant);
  const {
    data: countries
  } = (0, _staticApiClientReact.useGetTenantCountries)(customTenant ?? tenant);
  const availableOptions = phoneFormats?.allowedFormats.map(opt => ({
    countryCode: opt.countryCode === 'UK' ? 'GB' : opt.countryCode,
    label: opt.internationalPrefix,
    value: opt.internationalPrefix
  }));
  const isAnyPhoneFormats = Boolean(availableOptions?.length && availableOptions.length > 0);
  const onlyOnePrefix = availableOptions?.length === 1;
  const {
    getTestIdProps,
    getTestId
  } = (0, _testidGenerator.default)();
  const submitError = customErrors?.find(error => error.fieldName?.toLowerCase() === name.toLowerCase());
  const watchValue = watch(name);
  const formatError = (0, _lodash2.default)(submitError?.fieldName, '.').map(item => (0, _lodash.default)(item));
  const joinFormatError = formatError.join('.');
  (0, _react.useEffect)(() => {
    if (submitError) {
      setFocus(joinFormatError);
    }
  }, [customErrors, joinFormatError, setFocus, submitError]);
  const renderSelectOption = (item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
    value: item.value,
    ...getTestIdProps('select-field-option'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [item.countryCode ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactCountryFlag.default, {
        svg: true,
        countryCode: item.countryCode,
        style: {
          width: '18px',
          height: '18px',
          objectFit: 'cover',
          borderRadius: '50%',
          marginRight: '8px'
        }
      }) : null, getCountryByCountryCode(countries?.collection, item.countryCode), " (", item.label, ")"]
    })
  }, index);
  const errorMessage = submitError ? (0, _utils.getErrorLocalizationByCode)(submitError?.errorCode, name) : undefined;
  const readOnly = isAddressMatchRequired ?? false;
  const fieldPlaceholder = isAnyPhoneFormats ? customPlaceholderWithPrefix : customPlaceholder;
  const initialPrefix = availableOptions?.find(aopt => initialValue?.includes(aopt.value));
  (0, _react.useEffect)(() => {
    if (!phonePrefix && initialPrefix) {
      setPhonePrefix(initialPrefix.value);
    } else if (availableOptions && !phonePrefix) {
      setPhonePrefix(availableOptions[0]?.value);
    } else {
      setPhonePrefix(phonePrefix);
    }
  }, [initialPrefix, phonePrefix, availableOptions]);
  (0, _react.useEffect)(() => {
    if (watchValue && phonePrefix) {
      setPhoneWithoutPrefix(watchValue.replace(phonePrefix, ''));
    }
  }, [watchValue, phonePrefix]);
  (0, _react.useEffect)(() => {
    if (availableOptions && onlyOnePrefix) {
      setIsDisabledPrefix(true);
    }
    if (availableOptions && !initialPrefix && !phonePrefix) {
      setPhonePrefix(availableOptions[0]?.value);
    }
  }, [availableOptions, onlyOnePrefix, initialPrefix, phonePrefix]);
  const capitalize = enableLowercaseLetters ? 'off' : 'on';
  const readOnlyStyleBox = {
    display: 'flex',
    height: '0',
    alignItems: 'center',
    justifyContent: 'center'
  };
  const handleChangeAllowOnlyNumber = (available, value) => {
    let correctValue = value;
    if (available && correctValue.startsWith('0')) {
      correctValue = correctValue.slice(1).replaceAll(/\D/g, '');
    }
    if (available) {
      correctValue = correctValue.replaceAll(/\D/g, '');
    }
    const currentValue = isAnyPhoneFormats ?
    // eslint-disable-next-line unicorn/prefer-spread -- we need this type concat
    correctValue && phonePrefix?.concat(correctValue) : correctValue;
    return currentValue?.trim();
  };
  const handlePrefixChange = event => {
    const {
      target: {
        value
      }
    } = event;
    setPhonePrefix(value);
    setPhoneAutofocus(true);
    // eslint-disable-next-line unicorn/prefer-spread -- we need this type concat
    const currentValue = phoneWithoutPrefix && value?.concat(phoneWithoutPrefix);
    if (watchValue) {
      setValue(name, currentValue?.trim(), {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      });
    }
  };

  // we need start tabindex from 1 but displayOrder starts from 0
  const correctTabIndex = typeof displayOrder === 'number' ? displayOrder + 1 : displayOrder;
  const onlyOneOption = Boolean(availableOptions?.length && availableOptions.length === 1);
  const renderField = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    size: {
      xs: 12,
      sm: 12
    },
    style: {
      order: displayOrder
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      margin: readOnly ? '0' : '0 auto 20px',
      maxWidth: customMaxWidth ?? 500,
      style: readOnly ? readOnlyStyleBox : undefined,
      sx: {
        display: 'flex',
        width: '100%'
      },
      children: [isAnyPhoneFormats ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
        width: "auto",
        marginRight: 4,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledFormControl, {
          fullWidth: true,
          required: isMandatory,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputLabel, {
            id: `${name}-prefix-label`,
            children: labelWithPrefix
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Select, {
            displayEmpty: true,
            labelId: `${name}-prefix-label`,
            label: labelWithPrefix,
            variant: variant ?? 'outlined',
            required: isMandatory,
            disabled: !isEditable || isDisabledPrefix || isDisabled,
            inputProps: {
              tabIndex: correctTabIndex,
              autoFocus: phoneAutofocus
            },
            renderValue: selected => {
              if (!selected?.length) {
                return undefined;
              }
              const foundCode = availableOptions?.find(opt => opt.value === selected);
              if (foundCode?.countryCode) {
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)(FlagWrapper, {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactCountryFlag.default, {
                    svg: true,
                    countryCode: foundCode.countryCode,
                    style: {
                      width: '18px',
                      height: '18px',
                      objectFit: 'cover',
                      borderRadius: '50%',
                      marginRight: '8px'
                    }
                  }), selected]
                });
              }
              return selected;
            },
            sx: {
              '.MuiSelect-icon': {
                display: onlyOneOption ? 'none' : 'block'
              }
            },
            value: phonePrefix,
            defaultValue: phonePrefix,
            onChange: e => handlePrefixChange(e),
            children: availableOptions?.map(renderSelectOption)
          })]
        }, phonePrefix)
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
        maxWidth: isAnyPhoneFormats ? customMaxWidth ?? 380 : customMaxWidth ?? 500,
        width: "100%",
        display: "flex",
        alignItems: "end",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
          name: name,
          defaultValue: initialValue,
          render: ({
            field: {
              ref,
              onChange,
              ...field
            },
            fieldState
          }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SharedStyledComponents.StyledFormControl, {
            fullWidth: true,
            children: [readOnly ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
              fullWidth: true,
              label: isAnyPhoneFormats ? null : label,
              type: inputType ?? 'text',
              placeholder: fieldPlaceholder,
              variant: variant ?? 'outlined'
              // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical operator ||
              ,
              error: !!fieldState.error || Boolean(errorMessage),
              helperText: fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                ...getTestIdProps(`${name}-phone-field-error-message`),
                children: fieldState.error.message
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: errorMessage ? null : isAnyPhoneFormats ? helperTextWithPrefix : helperText
              }),
              disabled: isDisabled ?? !isEditable,
              required: isMandatory,
              inputProps: {
                inputMode: 'tel',
                'data-testid': getTestId(`${name}-phone-field`),
                autoCapitalize: capitalize,
                tabIndex: correctTabIndex,
                maxLength: maxLengthLimit,
                sx: {
                  '&::placeholder': {
                    textTransform: 'initial'
                  }
                },
                autoFocus
              }
              // eslint-disable-next-line react/jsx-no-duplicate-props --- we needed is not duplicate props
              ,
              InputProps: {
                endAdornment: fieldState.error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircleFilled, {
                  color: "error"
                }) : null,
                autoComplete: 'off',
                autoFocus,
                style: {
                  height: variant === 'standard' && isAnyPhoneFormats ? '48px' : 'unset'
                }
              },
              ...field,
              value: field.value?.replace(phonePrefix, ''),
              inputRef: ref,
              onChange: e => onChange(handleChangeAllowOnlyNumber(isAnyPhoneFormats, e.target.value))
            }), errorMessage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ErrorMessage, {
              errorMessage: errorMessage,
              customerLoginUrl: customerLoginUrl
            }) : null]
          })
        })
      })]
    })
  });
  const fieldComponent = isAvailable && renderField();
  return fieldComponent;
};
exports.PhoneFieldByConfig = PhoneFieldByConfig;
//# sourceMappingURL=PhoneFieldByConfig.js.map